import React from 'react';
import { Guideline } from '../../types/profileTypes';
import { BaseRequirementCard } from './BaseRequirementCard';
import { getSummaryText } from './utils';

interface ApprovedNutrientRelatedPhrasesCardProps {
  guideline: Guideline;
  index: number;
  onEditClick: () => void;
}

export const ApprovedNutrientRelatedPhrasesCard: React.FC<ApprovedNutrientRelatedPhrasesCardProps> = ({
  guideline,
  index,
  onEditClick
}) => {
  // Type guard to ensure we have the right guideline type
  if (guideline.type !== 'ApprovedNutrientRelatedPhrases') {
    return null;
  }

  const summaryText = getSummaryText(guideline);

  return (
    <BaseRequirementCard
      index={index}
      summaryText={summaryText}
      title={guideline.name}
      requirementTypeLabel="Approved Nutrient Related Phrases"
      onEditClick={onEditClick}
    />
  );
};
